<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('forthing.contract-history.title-label') }}</h3>
        </div>
        <div v-for="item in list">
            <div class="card mb-4">
                <div class="card-body d-flex flex-column flex-fill">
                    <div class="d-flex flex-row flex-fill">
                        <div class="d-flex flex-column flex-fill ml-3 align-content-stretch">
                            <div class="d-flex flex-row flex-fill flex-wrap">
                                <!-- 手続完了日 -->
                                <div class="d-flex flex-column flex-fill width-auto">
                                    <div class="font-weight-bold">
                                        {{ $t('forthing.contract-history.completion-date-label') }}
                                    </div>
                                    <div>
                                        {{ item.payment_date}}
                                    </div>
                                </div>

                                <!-- 送付量 (HEC) -->
                                <div class="d-flex flex-column flex-fill width-auto">
                                    <div class="font-weight-bold">
                                        {{ $t('forthing.contract-history.hec-label') }}
                                    </div>
                                    <div>
                                        <span v-if="item.amount_hec">
                                            {{ item.amount_hec | roundup }}
                                        </span>
                                        <span v-else>
                                            -
                                        </span>
                                    </div>
                                </div>

                                <!-- 送付量 (USDT) -->
                                <div class="d-flex flex-column flex-fill width-auto">
                                    <div class="font-weight-bold">
                                        {{ $t('forthing.contract-history.usdt-label') }}
                                    </div>
                                    <div>
                                        <span v-if="item.amount_usdt">
                                            {{ item.amount_usdt }}
                                        </span>
                                        <span v-else>
                                            -
                                        </span>
                                    </div>
                                </div>

                                <!-- 契約開始日 -->
                                <div class="d-flex flex-column flex-fill width-auto">
                                    <div class="font-weight-bold">
                                        {{ $t('forthing.contract-history.start-date-label') }}
                                    </div>
                                    <div>
                                        {{ item.enables_at }}                              
                                    </div>
                                </div>

                                <!-- 契約終了日 -->
                                <div class="d-flex flex-column flex-fill width-auto">
                                    <div class="font-weight-bold">
                                        {{ $t('forthing.contract-history.end-date-label') }}
                                    </div>
                                    <div>
                                        {{ item.expires_at }}                              
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UserService from './../../services/UserService';
    
    export default {
        name: 'historyOfForthingAgreement',

        data() {
            return {
                list: [],
            }
        },

        mounted() {
        },

        created() {
            this.getMembershipHistory();
        },

        methods: {
            async getMembershipHistory() {
                try {
                    const data = (await UserService.getMembershipHistory()).data;
                    if (data) {
                        for (let i in data) {
                            if (data.hasOwnProperty(i) && i !== 'meta') {
                                this.list.push(data[i]);
                            }
                        }
                    } else {
                        this.list = [];
                    }
                }catch{
                    this.list = [];
                }
            }
        }
    }
</script>

<style scoped>
    .width-75 {
        width: 75px;
    }
    .width-auto {
        width: auto;
    }

    @media screen and (max-width: 500px) {
        .width-auto,
        .width-75 {
            width: 100%;
        }
        .width-auto + .width-auto,
        .width-auto + .width-75 {
            margin-top: .5em;
        }
    }
</style>
